import TextFieldAdapter from '../../../../form/components/TextFieldAdapter';

export const CancellationCommentTextFieldAdapter = ({ label }: { label: string }) => {
  return <TextFieldAdapter name="cancellationComment" label={label} required multiline rows={3} />;
};
